const w = {
  directive: "wave",
  color: "currentColor",
  initialOpacity: 0.2,
  finalOpacity: 0.1,
  duration: 0.4,
  dissolveDuration: 0.15,
  easing: "ease-out",
  cancellationPeriod: 75,
  trigger: "auto",
  tagName: "div"
}, T = (t) => "config" in t && "globalProperties" in t.config, k = (t) => {
  let e;
  return t === "vue2" ? e = !1 : t === "vue3" ? e = !0 : e = T(t), e ? {
    mounted: "mounted",
    updated: "updated"
  } : {
    mounted: "inserted",
    updated: "componentUpdated"
  };
}, h = (t) => typeof t == "string" && t !== "auto", W = (t, e) => {
  t.dataset.vWaveBoundary = h(e) ? e : "true";
}, D = ({ borderTopLeftRadius: t, borderTopRightRadius: e, borderBottomLeftRadius: n, borderBottomRightRadius: i }, o) => {
  const a = document.createElement(o);
  return a.style.top = "0", a.style.left = "0", a.style.width = "100%", a.style.height = "100%", a.style.display = "block", a.style.position = "absolute", a.style.borderRadius = `${t} ${e} ${i} ${n}`, a.style.overflow = "hidden", a.style.pointerEvents = "none", a.style.webkitMaskImage = "-webkit-radial-gradient(white, black)", a;
}, j = (t, e, n, i) => {
  const o = document.createElement("div");
  return o.style.position = "absolute", o.style.width = `${n}px`, o.style.height = `${n}px`, o.style.top = `${e}px`, o.style.left = `${t}px`, o.style.background = i.color, o.style.borderRadius = "50%", o.style.opacity = `${i.initialOpacity}`, o.style.transform = "translate(-50%,-50%) scale(0)", o.style.transition = `transform ${i.duration}s ${i.easing}, opacity ${i.duration}s ${i.easing}`, o;
};
function m(t, e, n, i) {
  const o = t - n, a = e - i;
  return Math.sqrt(o * o + a * a);
}
function P(t, e, { width: n, height: i }) {
  const o = m(t, e, 0, 0), a = m(t, e, n, 0), v = m(t, e, 0, i), r = m(t, e, n, i);
  return Math.max(o, a, v, r);
}
const I = ({ x: t, y: e }, { top: n, left: i }) => ({
  x: t - i,
  y: e - n
}), f = "vWaveCountInternal";
function R(t) {
  const e = E(t);
  L(t, e + 1);
}
function S(t) {
  const e = E(t);
  L(t, e - 1);
}
function L(t, e) {
  t.dataset[f] = e.toString();
}
function E(t) {
  var e;
  return parseInt((e = t.dataset[f]) !== null && e !== void 0 ? e : "0", 10);
}
function _(t) {
  delete t.dataset[f];
}
const y = (t, e, n) => {
  const i = e.getBoundingClientRect(), o = window.getComputedStyle(e), { x: a, y: v } = I(t, i), r = 2.05 * P(a, v, i), s = D(o, n.tagName), c = j(a, v, r, n);
  R(e);
  let u = "";
  o.position === "static" && (e.style.position && (u = e.style.position), e.style.position = "relative"), s.appendChild(c), e.appendChild(s);
  let l = !1;
  const d = (C) => {
    typeof C < "u" && (document.removeEventListener("pointerup", d), document.removeEventListener("pointercancel", d)), l ? O() : l = !0;
  }, O = () => {
    c.style.transition = `opacity ${n.dissolveDuration}s linear`, c.style.opacity = "0", setTimeout(() => {
      s.remove(), S(e), E(e) === 0 && (_(e), e.style.position = u);
    }, n.dissolveDuration * 1e3);
  };
  document.addEventListener("pointerup", d), document.addEventListener("pointercancel", d);
  const $ = setTimeout(() => {
    document.removeEventListener("pointercancel", p), requestAnimationFrame(() => {
      c.style.transform = "translate(-50%,-50%) scale(1)", c.style.opacity = `${n.finalOpacity}`, setTimeout(() => d(), n.duration * 1e3);
    });
  }, n.cancellationPeriod), p = () => {
    clearTimeout($), s.remove(), document.removeEventListener("pointerup", d), document.removeEventListener("pointercancel", d), document.removeEventListener("pointercancel", p);
  };
  document.addEventListener("pointercancel", p);
}, g = /* @__PURE__ */ new WeakMap(), b = (t = {}, e = "vue3") => {
  const n = Object.assign(Object.assign({}, w), t), i = k(e), o = (r) => {
    const s = r.currentTarget.dataset.vWaveTrigger;
    document.querySelectorAll(`[data-v-wave-boundary="${s}"]`).forEach((u) => y(r, u, Object.assign(Object.assign({}, n), g.get(u))));
  }, a = {
    [i.mounted](r, { value: s = {} }) {
      var c;
      g.set(r, s), W(r, (c = s && s.trigger) !== null && c !== void 0 ? c : n.trigger), r.addEventListener("pointerdown", (u) => {
        if (g.get(r) === !1)
          return;
        const l = Object.assign(Object.assign({}, n), g.get(r));
        if (l.trigger === !1)
          return y(u, r, l);
        if (h(l.trigger))
          return;
        const d = r.querySelector('[data-v-wave-trigger="true"]');
        !d && l.trigger === !0 || d && !u.composedPath().includes(d) || y(u, r, l);
      });
    },
    [i.updated](r, { value: s = {} }) {
      var c;
      g.set(r, s), W(r, (c = s && s.trigger) !== null && c !== void 0 ? c : n.trigger);
    }
  }, v = {
    [i.mounted](r, { arg: s = "true" }) {
      r.dataset.vWaveTrigger = s, s !== "true" && r.addEventListener("pointerdown", o);
    },
    [i.updated](r, { arg: s = "true" }) {
      r.dataset.vWaveTrigger = s, s === "true" ? r.removeEventListener("pointerdown", o) : r.addEventListener("pointerdown", o);
    }
  };
  return {
    wave: a,
    vWave: a,
    waveTrigger: v,
    vWaveTrigger: v
  };
}, x = {
  install(t, e = {}) {
    if (this.installed)
      return;
    this.installed = !0;
    const n = Object.assign(Object.assign({}, w), e), { vWave: i, vWaveTrigger: o } = b(n, t);
    t.directive(n.directive, i), t.directive(`${n.directive}-trigger`, o);
  },
  installed: !1,
  createLocalWaveDirective: b
};
export {
  x as default
};
